// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import { PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc } from '../../routes/bids/components/PlanBasedBidsTable.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidContractProration_RevisionQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
}>;


export type BidContractProration_RevisionQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, type?: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, tradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, prorations: Array<{ __typename?: 'BidContractProration', id: string, costInCents: number, userEntered: boolean, lineItem: { __typename?: 'BidContractLineItem', id: string, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string } | { __typename?: 'ItemTemplateItem', id: string } | { __typename?: 'TakeoffLineItem', id: string } | { __typename?: 'TakeoffLineItemVersion', id: string } | null | undefined } }> }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, readyPlan: { __typename?: 'ReadyPlan', id: string } | { __typename?: 'PlanPackage', id: string } | { __typename?: 'DesignPackage', id: string } | { __typename?: 'ProductOffering', id: string } }> } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean } } };

export type BidContractProration_ScopeLinesQueryVariables = Types.Exact<{
  bidPackageVersionId: Types.Scalars['ID']['input'];
  filter: Types.BpvScopeLinesFilter;
}>;


export type BidContractProration_ScopeLinesQuery = { __typename?: 'Query', bidPackageVersionScopeLines: Array<{ __typename?: 'BidPackageScopeLine', takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, identity: { __typename?: 'TakeoffLineItem', id: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, number: string, name: string } }, bidItem?: { __typename?: 'BidItem', id: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, parent: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string }, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } | { __typename?: 'PlanPackage', id: string, name: string } | { __typename?: 'DesignPackage', id: string, name: string } | { __typename?: 'ProductOffering', id: string, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, laborLine?: { __typename?: 'TakeoffLineItem', id: string } | null | undefined, costEstimate: { __typename?: 'CostEstimate', costInCents: number }, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined } }> };

export type BidContractProrationTradeLineItemFragment = { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, prorations: Array<{ __typename?: 'BidContractProration', id: string, costInCents: number, userEntered: boolean, lineItem: { __typename?: 'BidContractLineItem', id: string, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string } | { __typename?: 'ItemTemplateItem', id: string } | { __typename?: 'TakeoffLineItem', id: string } | { __typename?: 'TakeoffLineItemVersion', id: string } | null | undefined } }> };

export const BidContractProrationTradeLineItemFragmentDoc = gql`
    fragment BidContractProrationTradeLineItem on BidContractTradeLineItem {
  id
  totalCostInCents
  bidItem {
    id
  }
  productOffering {
    id
  }
  options {
    id
  }
  prorations {
    id
    costInCents
    userEntered
    lineItem {
      id
      itemTemplateItem {
        id
      }
    }
  }
}
    `;
export const BidContractProration_RevisionDocument = gql`
    query BidContractProration_Revision($bidContractRevisionId: ID!) {
  bidContractRevision(id: $bidContractRevisionId) {
    id
    bidContract {
      id
      type {
        code
      }
      tradePartner {
        id
        name
      }
    }
    tradeLineItems {
      ...BidContractProrationTradeLineItem
    }
    bidPackageVersion {
      id
      readyPlanAggregateVersions {
        ...DisplayNamed
        readyPlan {
          id
        }
      }
    }
    canEdit {
      allowed
    }
  }
}
    ${BidContractProrationTradeLineItemFragmentDoc}
${DisplayNamedFragmentDoc}`;

/**
 * __useBidContractProration_RevisionQuery__
 *
 * To run a query within a React component, call `useBidContractProration_RevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractProration_RevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractProration_RevisionQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *   },
 * });
 */
export function useBidContractProration_RevisionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractProration_RevisionQuery, BidContractProration_RevisionQueryVariables> & ({ variables: BidContractProration_RevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractProration_RevisionQuery, BidContractProration_RevisionQueryVariables>(BidContractProration_RevisionDocument, options);
      }
export function useBidContractProration_RevisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractProration_RevisionQuery, BidContractProration_RevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractProration_RevisionQuery, BidContractProration_RevisionQueryVariables>(BidContractProration_RevisionDocument, options);
        }
export function useBidContractProration_RevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractProration_RevisionQuery, BidContractProration_RevisionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractProration_RevisionQuery, BidContractProration_RevisionQueryVariables>(BidContractProration_RevisionDocument, options);
        }
export type BidContractProration_RevisionQueryHookResult = ReturnType<typeof useBidContractProration_RevisionQuery>;
export type BidContractProration_RevisionLazyQueryHookResult = ReturnType<typeof useBidContractProration_RevisionLazyQuery>;
export type BidContractProration_RevisionSuspenseQueryHookResult = ReturnType<typeof useBidContractProration_RevisionSuspenseQuery>;
export type BidContractProration_RevisionQueryResult = Apollo.QueryResult<BidContractProration_RevisionQuery, BidContractProration_RevisionQueryVariables>;
export const BidContractProration_ScopeLinesDocument = gql`
    query BidContractProration_ScopeLines($bidPackageVersionId: ID!, $filter: BPVScopeLinesFilter!) {
  bidPackageVersionScopeLines(id: $bidPackageVersionId, filter: $filter) {
    takeoffLineItemVersion {
      ...PlanBasedBidsTable_TakeoffLineItemVersion
    }
  }
}
    ${PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc}`;

/**
 * __useBidContractProration_ScopeLinesQuery__
 *
 * To run a query within a React component, call `useBidContractProration_ScopeLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractProration_ScopeLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractProration_ScopeLinesQuery({
 *   variables: {
 *      bidPackageVersionId: // value for 'bidPackageVersionId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBidContractProration_ScopeLinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractProration_ScopeLinesQuery, BidContractProration_ScopeLinesQueryVariables> & ({ variables: BidContractProration_ScopeLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractProration_ScopeLinesQuery, BidContractProration_ScopeLinesQueryVariables>(BidContractProration_ScopeLinesDocument, options);
      }
export function useBidContractProration_ScopeLinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractProration_ScopeLinesQuery, BidContractProration_ScopeLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractProration_ScopeLinesQuery, BidContractProration_ScopeLinesQueryVariables>(BidContractProration_ScopeLinesDocument, options);
        }
export function useBidContractProration_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractProration_ScopeLinesQuery, BidContractProration_ScopeLinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractProration_ScopeLinesQuery, BidContractProration_ScopeLinesQueryVariables>(BidContractProration_ScopeLinesDocument, options);
        }
export type BidContractProration_ScopeLinesQueryHookResult = ReturnType<typeof useBidContractProration_ScopeLinesQuery>;
export type BidContractProration_ScopeLinesLazyQueryHookResult = ReturnType<typeof useBidContractProration_ScopeLinesLazyQuery>;
export type BidContractProration_ScopeLinesSuspenseQueryHookResult = ReturnType<typeof useBidContractProration_ScopeLinesSuspenseQuery>;
export type BidContractProration_ScopeLinesQueryResult = Apollo.QueryResult<BidContractProration_ScopeLinesQuery, BidContractProration_ScopeLinesQueryVariables>;